import React from "react";
import { IonItem } from "@ionic/react";
import { Button_Disclosure_Right_Grey } from "@assets/images";
import classNames from "classnames";

type Props = {
  title?: string;
  subTitle?: string;
  children?: React.ReactNode;
  subTitleIsError?: boolean;
  style?: React.CSSProperties;
  sideButton?: boolean;
  sideButtonText?: string;
  sidePill?: boolean;
  sidePillText?: string;
  topPill?: boolean;
  topPillText?: string;
  buttonClicked?: () => void;
  buttonPosition?: "top" | "middle";
  collapseBottomPadding?: boolean;
};

const ProgramInfoCardButton: React.FC<Props> = (props) => {
  return (
    <div className="flex justify-center mb-2">
      <IonItem
        button
        detail={false}
        onClick={props.buttonClicked}
        className="program-info-card-button relative max-w-app-column w-full bg-white"
      >
        <div className="flex flex-row items-center justify-between w-full pl-safe-area-l pr-safe-area-r">
          <div className={classNames("py-4 w-full", { "pb-0": props.collapseBottomPadding })}>
            <div
              className=""
              style={props.style}
            >
              <div className="flex flex-row justify-between">
                <div className="flex flex-col">
                  <div className="dashboardHeader">
                    <div className="text-acc-17px font-extrabold tracking-default leading-acc-lh text-grey-80">
                      {props.title}
                    </div>
                  </div>
                  {props.subTitle && (
                    <div className="text-acc-13px font-acc-normal leading-default tracking-default text-grey-70">
                      {props.subTitle}
                    </div>
                  )}
                </div>
                {props.buttonPosition === "top" && (
                  <img
                    className="w-24px h-24px min-w-[24px] min-h-[24px] mr-[-5px] flex flex-[-1]"
                    src={Button_Disclosure_Right_Grey}
                  />
                )}
              </div>
              <div className="programCardContent">{props.children}</div>
            </div>
          </div>
          {(props.buttonPosition === undefined || props.buttonPosition === "middle") && (
            <img
              className="w-24px h-24px min-w-[24px] min-h-[24px] flex flex-[-1]"
              src={Button_Disclosure_Right_Grey}
            />
          )}
        </div>
      </IonItem>
    </div>
  );
};

export default ProgramInfoCardButton;
